import type { Category } from '~~/types/commercetools';

export const extractAncestorsFromCategory = (category?: Category): Category[] => {

  if (!category) {

    return [];
  
  }

  const ancestors = category.ancestors || [];
  category.ancestors = [];

  return ancestors;

};
